import { type FC } from "react";
import { Checkbox, type CheckboxProps, FormControlLabel, styled } from "~/common/mui";
import { FontSize, getFontStyle } from "./materialInput/Fonts";
import { StyledFormControl } from "~/features/cart/B2CRequestPage/components/Checkboxes";

export type CheckboxWithLabelProps = JSX.IntrinsicElements["label"] &
  CheckboxProps & {
    centerCheckbox?: boolean;
    onCheck?: (val: boolean) => void;
    error?: boolean;
  };

export const CheckboxWithLabel: FC<CheckboxWithLabelProps> = ({
  className,
  children,
  onCheck,
  error,
  centerCheckbox = true,
  hidden,
  ...rest
}) => {
  return (
    <StyledFormControl error={error} hidden={hidden} className={className}>
      <FormControlLabel
        label={<Label>{children}</Label>}
        control={<Checkbox onChange={(event) => onCheck?.(event.target.checked)} {...rest} />}
      />
    </StyledFormControl>
  );
};

const Label = styled("div")({
  ...getFontStyle(FontSize.LabelLarge),
});
